/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var debounce = require("debounce");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
var Promise = require("promise");

// length of time to try calling each contact (in msec))
var call_duration = 30 * 1000;

// Length to wait for cycling when there is nobody online.
var cycle_time = 10 * 1000;

// Interval between triggers for calling to prevent spam or duplicates
var urgency_delay = 500;

// Time to wait for a connection to start
var connection_time = 30 * 1000;

/**
 * @module UrgencyCalls
 * @description This is the Model handles the making of 'urgency' calls by a User
 * on an aTouchAway.
 */
module.exports = Model({
	name: "urgencycalls",

	init: init,
	listeners: listeners,
	triggers: triggers,

	_started: false,

	start_calling: start_calling,
	cancel_calling: cancel_calling,
	succeed_calling: succeed_calling,
	clean_calling: clean_calling,
	load_next_contact: load_next_contact,

	timeout: timeout,
	clearTimer: clearTimer
});

function init() {
	this.push({
		active: false,
		cancelling: false
	});
}

function listeners() {
	return {
		"buzz:statechange": handle_buzz_state,
		"buzz:state:idle": load_next_contact,
		"buzz:state:connecting": start_timing_out_connection,
		"buzz:state:connected": succeed_calling,
		"nexturgencycontact:updated": perform_call,
		"urgencyhistory:started": begin_making_calls,
	};
}

function triggers() {
	return {
		"call": debounce(handle_urgency_call, urgency_delay),
		"start": start_calling,
		"stop": cancel_calling,
		"cancel:start": start_cancelling,
		"cancel:accept": accept_cancelling,
		"cancel:deny": deny_cancelling
	};
}

function handle_urgency_call(data) {
	if (this._started) {
		if (this.data.active) {
			return this.cancel_calling();
		}
		else return;
	}
	var reason = (data || {}).reason;

	this.start_calling(reason);
}

function clean_calling() {
	this.clearTimer();
	this._started = false;
	this.extend({
		active: false,
		cancelling: false
	});
	return Promise.all([
		AsyncStorage.setItem("urgencyID", ""),
		AsyncStorage.setItem("urgencyReason", "")
	]);
}

function succeed_calling() {
	if (!this.data.active) return;
	this.clean_calling();
	this.emit("urgencyhistory:trigger:accept");
}

function cancel_calling() {
	var was_active = this.data.active;
	if (!this._started) return;
	this.clean_calling();

	if (!was_active) return;

	this.emit("urgencyhistory:trigger:cancel");
	if (this._state === "calling") {
		this.emit("calling:trigger:hangup", {
			reason: "urgency:cancelled"
		});
	}
	this.emit("usermetrics:trigger:track", "cancel urgency call");
}

function start_calling(reason) {
	if (this._started) return;

	this._started = true;

	return AsyncStorage.setItem("urgencyReason", reason || "").then(function () {
		if (this._state !== "idle") {
			this.emit("buzz:trigger:hangup", {
				reason: "urgency:started"
			});
			this.emit("usermetrics:trigger:track", "hangup existing call and initiate urgency call", {
				reason,
			});
		}

		this.emit("urgencyhistory:trigger:start", {
			reason: reason
		});
		this.emit("ownbraceletevents:trigger:alert:alert");
		this.emit("usermetrics:trigger:track", "initiate urgency call", {
			reason,
		});
	}.bind(this));
}

function load_next_contact() {
	if (!this.data.active) return;
	this.emit("nexturgencycontact:trigger:next");
}

function begin_making_calls(data) {
	var urgencyID = data.call;
	return AsyncStorage.setItem("urgencyID", urgencyID).then(function () {
		this.emit("nexturgencycontact:trigger:reset");
		this.extend({
			active: true
		});
	}.bind(this));
}

function perform_call(contact) {
	if (!this.data.active) return;
	if (!contact)
		return this.timeout(load_next_contact.bind(this), cycle_time);

	this.emit("calling:trigger:call", {
		who: contact,
		reason: "urgency",
		ignoreBusy: true
	});

	// Create the banner and history item for the call
	this.emit("urgencyhistory:trigger:call", {
		contact: contact
	});

	this.timeout(timeout_call.bind(this), call_duration);
}

function start_timing_out_connection() {
	if (!this.data.active) return;
	this.timeout(timeout_call.bind(this), connection_time);
}

function timeout_call() {
	this.emit("calling:trigger:hangup", {
		reason: "urgency:timeout"
	});
}

function handle_buzz_state(state) {
	this._state = state;
}

function timeout(fn, time) {
	this.clearTimer();
	this._timer = setTimeout(fn, time);
}

function clearTimer() {
	if (!this._timer) return;
	clearTimeout(this._timer);
	this._timer = null;
}

function start_cancelling() {
	if (!this.data.active) return;
	this.extend({
		cancelling: true
	});
}

function deny_cancelling() {
	this.extend({
		cancelling: false
	});
}

function accept_cancelling() {
	this.cancel_calling();
}
